import { Component, Input, OnInit } from '@angular/core';
import { ValdnWidgetsComparisonModel } from 'src/app/models/widgets-validation/valdn-widgets-comparison.model';

@Component({
  selector: '[appValdnWidgetsComparison]',
  templateUrl: './valdn-widgets-comparison.component.html',
  styleUrls: ['./valdn-widgets-comparison.component.scss']
})
export class ValdnWidgetsComparisonComponent implements OnInit {
  @Input() data: ValdnWidgetsComparisonModel = new ValdnWidgetsComparisonModel();

  constructor() { }

  ngOnInit(): void {
  }
}
